import { AwaitResponse } from '@general/js/utils/MockUtils';
import mockedNavigation from '@/../mockedNavigation.json';
import mockedMaintenanceData from '@/../mockedMaintenanceData.json';
import AbstractClass from './CommonAbstractServices';

export default class CommonServices extends AbstractClass {
  /**
   * Mock check refresh cookie api. does not return anything
   */
  static getRefreshCookie() {
    return AwaitResponse(mockedMaintenanceData);
  }

  /**
   * Returns a mock data of footer, header, member details information and member details menu
   */
  static getNavigationAndMemberDetails() {
    return AwaitResponse(mockedNavigation);
  }

  /**
   * Returns mock data for search prediction
   */
  static getSearchPrediction() {
    return AwaitResponse(['Defence Health', 'Join Defence Health']);
  }

  static async raiseWorkItem() {
    return AwaitResponse(true);
  }

  /**
   * Returns mock data for search results
   */
  static getSearchResults() {
    const mockData = {
      searchText: '',
      pageNum: 1,
      pageSize: 10,
      totalNum: 8,
      showingSearchInformationText: null,
      results: [
        {
          title: 'The incredible battle',
          description:
            'In one of many letters, Paul wrote about his farewell march through the streets of Brisbane: “He heard a man with a big, loud voice in the crowd sing out, ‘good on ya dig’,” Robin reminisces. “He said...',
          publishDate: '2019-10-30',
          dateFriendly: '30 October 2019',
          objectType: 'Article',
          url: '/portal/Content/Member-HQ/2019/November/The-incredible-battle',
          breadcrumb: ['portal', 'Content', 'Member HQ', '2019', 'November', 'The incredible battle'],
          category: 'ADFCommunity',
        },
        {
          title: 'A conscript committed to doing his duty',
          description:
            'In June, Robin, along with several of Paul’s nieces, nephews and family friends, attended a preview as guests of the writer and director. Robin says they were well-prepared for the emotional roller-co...',
          publishDate: '2019-10-30',
          dateFriendly: '30 October 2019',
          objectType: 'Article',
          url: '/portal/Content/Member-HQ/2019/November/A-conscript-committed-to-doing-his-duty',
          breadcrumb: ['portal', 'Content', 'Member HQ', '2019', 'November', 'A conscript committed to doing his duty'],
          category: 'Family',
        },
        {
          title: 'Receiving horrendous news',
          description:
            'This experience contrasts starkly with the day she learned about Paul’s death. “He was killed on a Thursday, but we didn’t find out until the Saturday,” explains Robin, who lives in Coolah (in central...',
          publishDate: '2019-10-30',
          dateFriendly: '30 October 2019',
          objectType: 'Article',
          url: '/portal/Content/Member-HQ/2019/November/Receiving-horrendous-news',
          breadcrumb: ['portal', 'Content', 'Member HQ', '2019', 'November', 'Receiving horrendous news'],
          category: 'ADFCommunity',
        },
        {
          title: 'The Battle of Long Tan is on the big screen',
          description:
            'In one of many letters, Paul wrote about his farewell march through the streets of Brisbane: “He heard a man with a big, loud voice in the crowd sing out, ‘good on ya dig’,” Robin reminisces. “He said...',
          publishDate: '2019-10-30',
          dateFriendly: '30 October 2019',
          objectType: 'Article',
          url: '/portal/Content/Member-HQ/2019/November/The-Battle-of-Long-Tan-is-on-the-big-screen',
          breadcrumb: ['portal', 'Content', 'Member HQ', '2019', 'November', 'The Battle of Long Tan is on the big screen'],
          category: 'ADFCommunity',
        },
        {
          title: 'Contact Us',
          description: null,
          publishDate: '2021-08-26',
          dateFriendly: '26 August 2021',
          objectType: 'Page',
          url: '/portal/$memberNumber$/Support/Contact-Us',
          breadcrumb: ['portal', 'MemberNumber', 'Support', 'Contact Us'],
          category: '',
        },
        {
          title: 'Member HQ',
          description: null,
          publishDate: '2019-11-11',
          dateFriendly: '11 November 2019',
          objectType: 'Page',
          url: '/portal/Content/Member-HQ',
          breadcrumb: ['portal', 'Content', 'Member HQ'],
          category: '',
        },
        {
          title: 'Member Selection',
          description: null,
          publishDate: '2021-08-17',
          dateFriendly: '17 August 2021',
          objectType: 'Page',
          url: '/portal/$memberNumber$/Member-Selection',
          breadcrumb: ['portal', 'MemberNumber', 'Member Selection'],
          category: '',
        },
        {
          title: 'Benefit Quote',
          description: null,
          publishDate: '2021-10-22',
          dateFriendly: '22 October 2021',
          objectType: 'Page',
          url: '/portal/$memberNumber$/my-claims/benefit-quote',
          breadcrumb: ['portal', 'MemberNumber', 'My Claims', 'Benefit Quote'],
          category: '',
        },
      ],
    };

    return AwaitResponse(JSON.parse(JSON.stringify(mockData).tokenSwap()));
  }
}
